export const SiriContainer = ({focused}: {focused: boolean}) => {
    return (
      <div
        className="siri-container palette-4"
        style={{ opacity: focused ? 1 : 0.5, transition: '1s' }}
        >
        <div className="blobs">
          <svg viewBox="0 0 1200 1200">
            <g className="blob blob-1" style={{ animation: 'none' }}>
              <path />
            </g>
            <g className="blob blob-2" style={{ animation: 'none' }}>
              <path />
            </g>
            <g className="blob blob-3" style={{ animation: 'none' }}>
              <path />
            </g>
            <g className="blob blob-4" style={{ animation: 'none' }}>
              <path />
            </g>
            <g
              className="blob blob-1 alt"
              style={{ animation: 'none' }}
            >
              <path />
            </g>
            <g
              className="blob blob-2 alt"
              style={{ animation: 'none' }}
            >
              <path />
            </g>
            <g
              className="blob blob-3 alt"
              style={{ animation: 'none' }}
            >
              <path />
            </g>
            <g
              className="blob blob-4 alt"
              style={{ animation: 'none' }}
            >
              <path />
            </g>
          </svg>
        </div>
      </div>
    )
  }